<template>
    <div class="align-self-stretch flex-fill d-flex align-items-center justify-content-center">
        <div class="text-center">
            <h6>Messages have not been generated yet</h6>
            <button
                    class="btn btn-secondary my-4"
                    @click="$emit('generate')"
            >
                <i class="fas fa-cloud-rain"></i>
            </button>
            <div>Press the button to do it now</div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
    },
  }
</script>
